import { render, staticRenderFns } from "./BaseHeaderBar.vue?vue&type=template&id=20dc3653&scoped=true&"
import script from "./BaseHeaderBar.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderBar.vue?vue&type=style&index=0&id=20dc3653&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc3653",
  null
  
)

export default component.exports